import { findRouterContext } from '../../common/utils';
export const invokePluginLoad = (plugins, {
  routes,
  history,
  basePath
}) => {
  const context = findRouterContext(routes, {
    location: history.location,
    basePath
  });
  plugins.forEach(p => {
    p.routeLoad == null || p.routeLoad({
      context
    });
  });
};